export default __webpack_public_path__ + "static/media/icn-distance-ecoroll.a10417d3.svg";